import React, { Fragment } from 'react';
import IntlMessages from 'util/IntlMessages';
import BasicDetailRow from 'components/basicDetailRow';

const TeamDetailTable = ({ displayData }) => {
    if (displayData) {
        return (
            <table className="default-table table table-sm table-responsive-sm table-hover">
                <tbody>
                    <BasicDetailRow label={<IntlMessages id="label.description" />} description={displayData?.description} />
                </tbody>
            </table>
        );
    } else {
        return <Fragment></Fragment>;
    }
};

export default TeamDetailTable;


// WEBPACK FOOTER //
// ./components/Agile/team/teamDetail/teamDetailTable/index.js